import { useState } from 'react';
import { activeOrganizationId, graphql } from '../api/client';
import { uploadContract } from '../api/documents';
import { useAuth } from '../auth/AuthProvider';

export type ContractDocument = { id: string; fileName: string; status: string; createdAt: string };

/** The contracts kept with a job: download one, or add one. Only the file is kept; PayRight reads none of it. */
export function ContractFile({ projectId, documents, onChange, notice }: { projectId: string; documents: ContractDocument[]; onChange: () => void; notice?: string }) {
  const { token } = useAuth();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  async function add(file: File | undefined) {
    if (!file || !token) return;
    setBusy(true); setError('');
    try { await uploadContract({ token, projectId, file }); onChange(); }
    catch (reason) { setError(reason instanceof Error ? reason.message : 'The contract could not be saved.'); }
    finally { setBusy(false); }
  }
  async function download(id: string) {
    if (!token) return;
    try {
      const result = await graphql<{ documentDownload: { downloadUrl: string } }>({ query: 'query Download($id:ID!){documentDownload(id:$id){downloadUrl}}', variables: { id }, token, organizationId: activeOrganizationId() });
      window.location.assign(result.documentDownload.downloadUrl);
    } catch (reason) { setError(reason instanceof Error ? reason.message : 'The contract could not be downloaded.'); }
  }
  return <section className="workspace-section" aria-labelledby="contract-file-heading">
    <div className="section-heading"><div><h2 id="contract-file-heading">Your contract</h2>
      <p>The contract you keep with this job. Your company and PayRight staff can open it. PayRight does not read or analyze it; it uses only the details and notice terms you confirmed.</p></div></div>
    {notice && <div className="alert error" role="alert">{notice}</div>}
    {error && <div className="alert error" role="alert">{error}</div>}
    {documents.length === 0 ? <p className="workspace-intro">No contract is kept with this job.</p>
      : <ul>{documents.map(document => <li key={document.id}>{document.fileName} <button type="button" className="button button-quiet" onClick={() => void download(document.id)}>Download</button></li>)}</ul>}
    <label>Add a contract (PDF or text file)<input type="file" accept=".pdf,.txt,application/pdf,text/plain" disabled={busy} onChange={event => { void add(event.target.files?.[0]); event.target.value = ''; }} /></label>
    {busy && <p role="status">Saving your contract…</p>}
  </section>;
}
